import { c as _c } from "react/compiler-runtime";
import { useEffect, useLayoutEffect, useRef } from 'react';
export function useTimeout(callback, delay, t0) {
  const $ = _c(10);
  let t1;
  if ($[0] !== t0) {
    t1 = t0 === undefined ? [] : t0;
    $[0] = t0;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const dependencies = t1;
  const savedCallback = useRef(callback);
  let t2;
  let t3;
  if ($[2] !== callback) {
    t2 = () => {
      savedCallback.current = callback;
    };
    t3 = [callback];
    $[2] = callback;
    $[3] = t2;
    $[4] = t3;
  } else {
    t2 = $[3];
    t3 = $[4];
  }
  useIsomorphicLayoutEffect(t2, t3);
  let t4;
  if ($[5] !== delay) {
    t4 = () => {
      if (!delay && delay !== 0) {
        return;
      }
      const id = setTimeout(() => {
        savedCallback.current();
      }, delay);
      return () => {
        clearTimeout(id);
      };
    };
    $[5] = delay;
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  let t5;
  if ($[7] !== delay || $[8] !== dependencies) {
    t5 = [delay, ...dependencies];
    $[7] = delay;
    $[8] = dependencies;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  useEffect(t4, t5);
}
const useIsomorphicLayoutEffect = typeof window !== 'undefined' ? useLayoutEffect : useEffect;